export const DEFAULT_ERROR_MESSAGE = "Sorry, something went wrong. Please try again."
export const SNACK_BAR_DELAY_TIME = 3000
